import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'app',
    loadChildren: () => import('./tabs/tabs.module').then( m => m.TabsPageModule)
  },
  {
    path: 'signup',
    loadChildren: () => import('./signup/signup.module').then( m => m.SignupPageModule)
  },
  {
    path: 'bewerber',
    loadChildren: () => import('./bewerber/bewerber.module').then( m => m.BewerberPageModule)
  },
  {
    path: 'emailverify',
    children: [
      {
        path: "",
        loadChildren: () => import('./email-verification/email-verification.module').then( m => m.EmailVerificationPageModule)  
      },
      {
        path: "email/:id",
        children: [
          {
            path: "",
            loadChildren: () => import('./email-verification/email-verification.module').then( m => m.EmailVerificationPageModule)    
          }
        ]
      },
    ] 
  },
  {
    path: 'emailverify/email/:id',
    children: [
      {
        path: "",
        loadChildren: () => import('./email-verification/email-verification.module').then( m => m.EmailVerificationPageModule)  
      },
    ] 
  },
  {
    path: 'bewerber-followup/:id',
    loadChildren: () => import('./bewerber-followup/bewerber-followup.module').then( m => m.BewerberFollowupPageModule)
  },
  {
    path: 'bewerber-followup',
    loadChildren: () => import('./bewerber-followup/bewerber-followup.module').then( m => m.BewerberFollowupPageModule)
  },


];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
